const KNOWN_DOMAINS = {
    "m.facebook.com": "FACEBOOK",
    "www.facebook.com": "FACEBOOK",
    "lm.facebook.com": "FACEBOOK",
    "l.facebook.com": "FACEBOOK",
    "t.co": "TWITTER",
    "www.twitter.com": "TWITTER",
    "www.linkedin.com": "LINKEDIN",
    "lnkd.in": "LINKEDIN",
    "touch.www.linkedin.com": "LINKEDIN",
    "plus.url.google.com": "GOOGLE_PLUS",
    "www.reddit.com": "REDDIT",
    "www.bloomberg.com": "BLOOMBERG",
};

const baseUrlPattern = /https?:\/\/([^ /]+)/;

export default function getReferrerName(referringUrl) {
    const baseUrlMatch = baseUrlPattern.exec(referringUrl);

    return (baseUrlMatch === null || baseUrlMatch === "") ? referringUrl : (KNOWN_DOMAINS[baseUrlMatch[1]] || baseUrlMatch[1]);
}
